import { useEffect, useState, useMemo } from "react";
import "../../assets/css/Leads/LeadDrawer.css";
import api from "../../api/axios";
import Swal from "sweetalert2";
import { MdClose } from "react-icons/md";
import FollowUpModal from "../FollowUp/FollowUpModal";
import ExpensesCreate from "../Expenses/ExpensesCreate";
import FollowUpLeadList from "../FollowUp/FollowUpList";
import DealsCreate from "../Deals/DealsCreate";
import RenewalCreate from "../Renewal/RenewalsCreate";
import ExpensesList from "../Expenses/ExpenseDynamic";
import Pipeline from "../Common/Pipeline";
import {
  FaEdit,
  FaTrashAlt,
  FaMoneyBillWave,
  FaUser,
  FaBuilding,
  FaPhoneAlt,
  FaSyncAlt
} from "react-icons/fa";


export default function LeadDrawer({
  lead,
  isOpen,
  onClose,
  refreshLeads,
  initialTab = "overview",
}) {
  const [formData, setFormData] = useState({
    title: lead?.title || "",
    status: lead?.status || "",
    lead_type: lead?.lead_type || "",
    source: lead?.source || "",
    value: lead?.value || "",
    description: lead?.description || "",
    assigned_to: lead?.assigned_to || "",
  });
  const [showFollowup, setShowFollowup] = useState(false);
  const [showFollowupModal, setShowFollowupModal] = useState(false);
  const [showExpense, setShowExpense] = useState(false);
  const [showRenewalModal, setShowRenewalModal] = useState(false);
  const [showDealModal, setShowDealModal] = useState(false);
  const [pendingFollowup, setPendingFollowup] = useState(null);
  const [users, setUsers] = useState([]);
  const [followupRefreshKey, setFollowupRefreshKey] = useState(0);
  const [expenseRefreshKey, setExpenseRefreshKey] = useState(0);

  const [activeTab, setActiveTab] = useState(initialTab || "overview");
  const [editMode, setEditMode] = useState(false);

  const [loading, setLoading] = useState(false);
  const [leadData, setLeadData] = useState(lead);

  const visiblePipeline = useMemo(() => {
    if (!leadData?.pipeline) return [];

    // If lead is Lost, don't show Deal Confirmation stage
    if (leadData.status === "Lost") {
      return leadData.pipeline.filter(
        (step) => step.stage !== "Deal Confirmation" && step.stage !== "Converted"
      );
    }

    // Otherwise hide Lost stage
    return leadData.pipeline.filter(
      (step) => step.stage !== "Lost"
    );
  }, [leadData]);



  //Logic to determine user permissions based on role

  const currentUser = JSON.parse(sessionStorage.getItem("user"));

  const role = currentUser?.role?.toLowerCase();

  const permissions = {
    "super admin": {
      edit: true,
      delete: true,
    },
    "sales manager": {
      edit: true,
      delete: false,
    },
    "sales executive": {
      edit: false,
      delete: false,
    },
  };

  const permission = permissions[role] || {
    edit: false,
    delete: false,
  };







  const fetchLead = async () => {
    try {
      const res = await api.get(`/lead/get/${lead.id}`);
      console.log("Fetched Lead:", res.data);

      setLeadData(res.data);

      setFormData({
        title: res.data.title || "",
        status: res.data.status || "",
        lead_type: res.data.lead_type || "",
        source: res.data.source || "",
        value: res.data.value || "",
        description: res.data.description || "",
        assigned_to: res.data.assigned_to || "",
      });
      return res.data;
    } catch (err) {
      console.error("Failed to fetch lead", err);
      return null;
    }
  };
  const sourceOptions = [
    { value: "Website", label: "Website" },
    { value: "Referral", label: "Referral" },
    { value: "Phone", label: "Phone" },
    { value: "Email", label: "Email" },
    { value: "Social Media", label: "Social Media" },
    { value: "Manual", label: "Manual" },
  ];

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await api.get("/users"); // adjust endpoint if different
        setUsers(res.data || []);
      } catch (err) {
        console.error("Failed to load users", err);
      }
    };

    fetchUsers();
  }, []);


  //Validation for form fields


  const [errors, setErrors] = useState({
    title: "",
    lead_type: "",
    source: "",
    status: "",
    value: "",
    assigned_to: "",
    description: "",
  });


  const validateForm = () => {
    const newErrors = {};

    // Lead Name
    if (!formData.title?.trim()) {
      newErrors.title = "Lead name is required";
    } else if (formData.title.trim().length > 100) {
      newErrors.title = "Lead name cannot exceed 100 characters";
    }

    // Lead Type
    if (!formData.lead_type?.trim()) {
      newErrors.lead_type = "Lead type is required";
    }

    // Source
    if (!formData.source) {
      newErrors.source = "Source is required";
    }

    // Status
    if (!formData.status) {
      newErrors.status = "Status is required";
    }

    // Expected Revenue
    if (
      formData.value === "" ||
      formData.value === null ||
      formData.value === undefined
    ) {
      newErrors.value = "Expected revenue is required";
    } else if (isNaN(formData.value) || Number(formData.value) < 0) {
      newErrors.value = "Enter a valid amount";
    }

    // Assigned To
    if (!formData.assigned_to) {
      newErrors.assigned_to = "Assigned user is required";
    }

    // Description
    if (!formData.description?.trim()) {
      newErrors.description = "Description is required";
    } else if (formData.description.trim().length > 1000) {
      newErrors.description = "Description cannot exceed 1000 characters";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };


  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };








  // ---------------- SYNC LEAD ----------------
  // useEffect(() => {
  //   if (!lead?.id) return;

  //   setFormData({
  //     title: lead.title || "",
  //     status: lead.status || "New",
  //     lead_type: lead.lead_type || "",
  //     source: lead.source || "",
  //     value: lead.value || "",
  //     description: lead.description || "",
  //     assigned_to: lead.assigned_to || "",
  //   });

  //   setEditMode(false);
  //   setActiveTab("overview");
  // }, [lead?.id]);

  useEffect(() => {
    if (!lead?.id) return;

    setEditMode(false);
    setActiveTab(initialTab || "overview");
    setErrors({});

    fetchLead();

  }, [lead?.id, initialTab]);

  useEffect(() => {
    if (isOpen && initialTab) {
      setActiveTab(initialTab);
    }
  }, [isOpen, initialTab]);


  if (!isOpen || !lead?.id) return null;





  // ---------------- UPDATE LEAD ----------------
  const updateLead = async () => {
    if (!validateForm()) return;
    try {
      setLoading(true);

      const payload = {
        title: formData.title,
        status: formData.status,
        lead_type: formData.lead_type,
        source: formData.source,
        value: Number(formData.value),
        description: formData.description,
        assigned_to: formData.assigned_to,
      };

      await api.put(`/lead/update/${lead.id}`, payload);

      await Swal.fire({
        icon: "success",
        title: "Lead Updated",
        timer: 1500,
        showConfirmButton: false,
      });

      await refreshLeads?.();
      setEditMode(false);
      onClose();
    } catch (err) {
      console.error("Update error:", err);
      Swal.fire({
        icon: "error",
        title: "Update Failed",
      });
    } finally {
      setLoading(false);
    }
  };

  const getInitials = (name = "") => {
    return name
      .split(" ")
      .map((word) => word[0])
      .join("")
      .substring(0, 2)
      .toUpperCase();
  };


  // ---------------- DELETE LEAD ----------------
  const deleteLead = async () => {
    const res = await Swal.fire({
      title: "Delete this lead?",
      text: "This action cannot be undone",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc2626",
      confirmButtonText: "Yes, Delete",
    });

    if (!res.isConfirmed) return;

    try {
      await api.delete(`/lead/delete/${lead.id}`);

      await Swal.fire({
        icon: "success",
        title: "Lead Deleted",
        timer: 1500,
        showConfirmButton: false,
      });

      await refreshLeads?.();
      onClose();
    } catch (err) {
      console.error("Delete error:", err);
      Swal.fire({
        icon: "error",
        title: "Delete Failed",
      });
    }
  };


  const statusColors = {
    New: "#2563eb",
    Qualified: "#9333ea",
    "Proposal Sent": "#ca8a04",
    Negotiation: "#ea580c",
    "Deal Confirmation": "#16a34a",
    Converted: "#16a34a",
    Lost: "#dc2626",
  };
  const stageColors = {
    New: "#86efac",             // light green
    Qualified: "#a855f7",       // purple
    "Proposal Sent": "#facc15", // yellow
    Negotiation: "#f97316",     // orange
    "Deal Confirmation": "#22c55e", // green
    Converted: "#22c55e",       // green
    Lost: "#ef4444",            // red
  };
  const pipelineColor =
    statusColors[formData.status] || "#2563eb";

  const isFollowUpDisabled =
    lead?.status === "Deal Confirmation" || lead?.status === "Converted" || lead?.status === "Lost";


  return (
    <div className="drawer-overlay" onClick={onClose}>
      <div className="lead-drawer" onClick={(e) => e.stopPropagation()}>

        <div className="drawer-header">
          <div className="drawer-top">

            <div className="header-left">
              <div className="lead-header-info">

                <div className="lead-avatar">
                  {getInitials(formData.title)}
                </div>

                <div className="lead-info">

                  <div className="lead-title-row">
                    <h2>{formData.title || "Untitled Lead"}</h2>

                    <div className="lead-badges">
                      <span className="status-badge">
                        {formData.status}
                      </span>

                      <span className="type-badge">
                        {formData.lead_type}
                      </span>
                    </div>
                  </div>

                  <div className="drawer-bottom">
                    <button
                      className="action-btn secondary"
                      onClick={() => setShowFollowup(true)}
                      disabled={isFollowUpDisabled}
                    >
                      <FaPhoneAlt size={12} />
                      Follow Up
                    </button>
                    <button
                      className="action-btn secondary"
                      onClick={() => setShowExpense(true)}
                    >
                      <FaMoneyBillWave size={12} />
                      Expense
                    </button>
                    <button
                      className="action-btn secondary"
                      onClick={() => setShowRenewalModal(true)}
                    >
                      <FaSyncAlt size={12} />
                      Renewal
                    </button>
                  </div>

                </div>

              </div>
            </div>

            <div className="header-right">
              {!editMode && (
                <div className="header-icon-actions">
                  {permission.edit && (
                    <button
                      className="icon-btn edit-btn"
                      onClick={() => setEditMode(true)}
                    >
                      <FaEdit />
                    </button>
                  )}

                  {permission.delete && (
                    <button
                      className="icon-btn delete-btn"
                      onClick={deleteLead}
                    >
                      <FaTrashAlt />
                    </button>
                  )}
                </div>
              )}

              <button
                className="close-btn"
                aria-label="Close drawer"
                onClick={onClose}
              >
                <MdClose />
              </button>
            </div>

          </div>
        </div>
        {/* TABS */}
        <div className="drawer-tabs-l">
          <div className="drawer-tabs-top">

            <button
              className={activeTab === "overview" ? "active-tab" : ""}
              onClick={() => setActiveTab("overview")}
            >
              Overview
            </button>

            <button
              className={activeTab === "activity" ? "active-tab" : ""}
              onClick={() => setActiveTab("activity")}
            >
              Activity
            </button>

            <button
              className={activeTab === "expenses" ? "active-tab" : ""}
              onClick={() => setActiveTab("expenses")}
            >
              Expenses
            </button>
          </div>


        </div>

        {/* OVERVIEW */}
        {activeTab === "overview" && (
          <div className="drawer-section">
            <div className="drawer-content">

              <Pipeline steps={visiblePipeline} />

              {/* DETAILS */}
              <div className="detail-grid">

                <div>
                  <label>Lead Name</label>

                  {editMode ? (
                    <>
                      <input
                        name="title"
                        value={formData.title}
                        onChange={handleChange}
                        className={errors.title ? "error" : ""}
                      />

                      {errors.title && (
                        <span className="error-text">{errors.title}</span>
                      )}
                    </>
                  ) : (
                    <p>{formData.title || "-"}</p>
                  )}
                </div>

                <div>
                  <label>Lead Type</label>

                  {editMode ? (
                    <>
                      <input
                        name="lead_type"
                        value={formData.lead_type}
                        onChange={handleChange}
                        className={errors.lead_type ? "error" : ""}
                      />

                      {errors.lead_type && (
                        <span className="error-text">{errors.lead_type}</span>
                      )}
                    </>
                  ) : (
                    <p>{formData.lead_type || "-"}</p>
                  )}
                </div>

                <div>
                  <label>Source</label>

                  {editMode ? (
                    <>
                      <select
                        name="source"
                        value={formData.source}
                        onChange={handleChange}
                        className={errors.source ? "error" : ""}
                      >
                        {sourceOptions.map((s) => (
                          <option key={s.value} value={s.value}>
                            {s.label}
                          </option>
                        ))}
                      </select>

                      {errors.source && (
                        <span className="error-text">{errors.source}</span>
                      )}
                    </>
                  ) : (
                    <p>{formData.source || "-"}</p>
                  )}
                </div>

                <div>
                  <label>Status</label>
                  {editMode ? (
                    <select
                      name="status"
                      value={formData.status}
                      onChange={handleChange}
                    >
                      <option value="New">New</option>
                      <option value="Qualified">Qualified</option>

                      <option value="Proposal Sent">Proposal Sent</option>
                      <option value="Negotiation">Negotiation</option>
                      <option value="Deal Confirmation">Deal Confirmation</option>
                      <option value="Lost">Lost</option>
                    </select>
                  ) : (
                    <p>{formData.status || "-"}</p>
                  )}
                </div>






                <div>
                  <label>Expected Revenue</label>

                  {editMode ? (
                    <>
                      <input
                        type="number"
                        name="value"
                        value={formData.value || ""}
                        onChange={handleChange}
                        className={errors.value ? "error" : ""}
                      />

                      {errors.value && (
                        <span className="error-text">{errors.value}</span>
                      )}
                    </>
                  ) : (
                    <p>{Number(lead.value).toLocaleString("en-IN") || "-"}</p>
                  )}
                </div>
                <div>
                  <label>Assigned To</label>

                  {editMode ? (
                    <>
                      <select
                        name="assigned_to"
                        value={formData.assigned_to || ""}
                        onChange={handleChange}
                        className={errors.assigned_to ? "error" : ""}
                      >
                        {users.map((user) => (
                          <option key={user.id} value={user.id}>
                            {user.name}
                          </option>
                        ))}
                      </select>

                      {errors.assigned_to && (
                        <span className="error-text">{errors.assigned_to}</span>
                      )}
                    </>
                  ) : (
                    <p>
                      {users.find((u) => u.id === formData.assigned_to)?.name || "-"}
                    </p>
                  )}
                </div>
                <div>
                  <label>Created By</label>
                  <p>{lead.created_by?.name || lead.created_by || "-"}</p>
                </div>
                <div className="full-width">
                  <label>Description</label>

                  {editMode ? (
                    <>
                      <textarea
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        className={errors.description ? "error" : ""}
                      />

                      {errors.description && (
                        <span className="error-text">{errors.description}</span>
                      )}
                    </>
                  ) : (
                    <p>{formData.description || "-"}</p>
                  )}
                </div>
              </div>

              {/* ACTIONS */}
              {editMode && (
                <div className="overview-actions">
                  <button
                    className="btn-secondary"
                    onClick={() => {
                      setFormData({
                        title: lead.title || "",
                        status: lead.status || "New",
                        lead_type: lead.lead_type || "",
                        source: lead.source || "",
                        value: lead.value || "",
                        description: lead.description || "",
                        assigned_to: lead.assigned_to || "",
                      });

                      setEditMode(false);
                    }}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn-primary"
                    onClick={updateLead}
                    disabled={loading}
                  >
                    {loading ? "Saving..." : "Save Changes"}
                  </button>
                </div>
              )}
            </div>
            {/* ORGANIZATION */}
            <div className="info-section">
              <div className="section-title">
                <FaBuilding />
                <span>Organization</span>
              </div>

              {lead.organization ? (
                <div className="crm-card">
                  <div className="crm-card-icon building">
                    <FaBuilding />
                  </div>

                  <div className="crm-card-content">
                    <h4>{lead.organization.name}</h4>

                    <p>{lead.organization.website}</p>

                    <div className="crm-meta">
                      <span>{lead.organization.country}</span>
                      <span>{lead.organization.state}</span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="empty-card">No Organization Linked</div>
              )}
            </div>
            {/* CONTACT */}
            <div className="info-section">
              <div className="section-title">
                <FaUser />
                <span>Contact</span>
              </div>

              {lead.contact ? (
                <div className="crm-card">
                  <div className="crm-card-icon">
                    <FaUser />
                  </div>

                  <div className="crm-card-content">
                    <h4>
                      {lead.contact.first_name} {lead.contact.last_name}
                    </h4>

                    <p>{lead.contact.designation}</p>

                    <div className="crm-meta">
                      <span>{lead.contact.email}</span>
                      <span>{lead.contact.phone}</span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="empty-card">No Contact Linked</div>
              )}
            </div>


          </div>
        )}

        {activeTab === "activity" && (
          <div className="activity-tab">
            <FollowUpLeadList
              leadId={lead.id}
              refreshKey={followupRefreshKey}
            />
          </div>
        )}

        {activeTab === "expenses" && (
          <div className="expenses-tab">
            <ExpensesList
              leadId={lead.id}
              refreshKey={expenseRefreshKey}
              onAddExpense={() => setShowExpense(true)}
            />
          </div>
        )}


        {/* <FollowUpModal
          type="lead"
          id={lead.id}
          isOpen={showFollowup}
          onClose={() => setShowFollowup(false)}
          onSuccess={() => {
            setShowFollowup(false);
            setFollowupRefreshKey((prev) => prev + 1);
          }}
        /> */}

        <FollowUpModal
          type="lead"
          id={lead.id}
          lead={lead}
          usersList={users}
          isOpen={showFollowup}
          onClose={() => {
            setShowFollowup(false);
            setPendingFollowup(null);
          }}
          onSuccess={async (followupResult) => {
            setShowFollowup(false);

            if (followupResult?.isPendingDealConfirmation) {
              setPendingFollowup(followupResult.pendingFollowup || followupResult);
              setShowDealModal(true);
              return;
            }

            setFollowupRefreshKey((prev) => prev + 1);
            const updated = await fetchLead(); // Refresh drawer details
            await refreshLeads?.(); // Refresh list

            const isConverted =
              followupResult?.isConverted ||
              followupResult?.status === "Deal Confirmation" ||
              followupResult?.status === "Converted" ||
              updated?.status === "Deal Confirmation" ||
              updated?.status === "Converted";

            if (isConverted) {
              setShowDealModal(true);
            }
          }}
        />


        {showExpense && (
          <ExpensesCreate
            leadId={lead.id}
            organizationId={lead.organization?.id}
            isOpen={showExpense}
            onClose={() => setShowExpense(false)}
            onSuccess={() => {
              setExpenseRefreshKey((prev) => prev + 1);
              setShowExpense(false);
            }}
          />
        )}

        {/* <DealsCreate
          isOpen={showDealModal}
          onClose={() => setShowDealModal(false)}
          lead={lead}
          onSuccess={() => {
            setShowDealModal(false);

            refreshLeads?.();
          }}
        /> */}

        <DealsCreate
          isOpen={showDealModal}
          onClose={() => {
            setPendingFollowup(null);
            setShowDealModal(false);
          }}
          lead={leadData || lead}
          pendingFollowup={pendingFollowup}
          isConversionFlow={true}
          onSuccess={async () => {
            setPendingFollowup(null);
            await refreshLeads?.();
            setShowDealModal(false);
            onClose();   // Close drawer
          }}
        />

        {showRenewalModal && (
          <RenewalCreate
            leadId={lead.id}
            organizationId={lead.organization?.id}
            contactId={lead.contact?.id}
            onClose={() => setShowRenewalModal(false)}
            onSuccess={() => {
              setShowRenewalModal(false);
              refreshLeads?.();
            }}
          />
        )}
      </div>
    </div>
  );
}